export const apiPrefix = '/api/ft/v1'
export const typingDelay = 250
export const manualLink = 'https://help.fit.cvut.cz/projects-fit/index.html'
export const stateExamsLink = 'https://courses.fit.cvut.cz/SZZ/'
export const issuesLink = 'https://servicedesk.cvut.cz/Alvao/Ticket/NewFromCatalog?SectionID=1152'
export const personRegistrationLink = 'https://externiste.fit.cvut.cz/'
